import { TsrctContractDemandStatus } from '@/generated/gql/graphql';

const CONTRACT_DEMAND_STATUS_EDITABLE: Record<TsrctContractDemandStatus, boolean> = {
  [TsrctContractDemandStatus.DRAFT]: true,
  [TsrctContractDemandStatus.IN_PROGRESS]: false,
  [TsrctContractDemandStatus.AWARDED]: false,
  [TsrctContractDemandStatus.CANCELLED]: false,
};

export const isContractDemandEditable = (contractDemand?: { status: TsrctContractDemandStatus }) => {
  return contractDemand ? CONTRACT_DEMAND_STATUS_EDITABLE[contractDemand.status] : false;
};
